module.exports = __webpack_public_path__ + "static/media/menuIcon.787a1072.svg";